import {createListFromObject} from "../../../../Utilities/Types/listUtilities";
import {LOAN_LIBRARY_LOAN_STATUS} from "../../../Library/LoanLibrary/LoanLibraryQueue/loanLibraryQueueFactory";

export const LOAN_LIBRARY_LOAN_STATUS_LIST = createListFromObject(LOAN_LIBRARY_LOAN_STATUS);

export const LOAN_LIBRARY_LOAN_STATUS_LIST_FOR_UPDATE = LOAN_LIBRARY_LOAN_STATUS_LIST;

